'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _extends = require('./extends-214be52a.js');

var defineProperty = require('./defineProperty-754b29ce.js');

var React = require('react');

var index = require('./index-6b8189f0.js');

var getDisplayName = require('./getDisplayName-fd5924a6.js');

var url = require('./url.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PublicUrlContext = /*#__PURE__*/React__default["default"].createContext('');
var Provider = PublicUrlContext.Provider,
    Consumer = PublicUrlContext.Consumer;

var PublicUrlProvider = /*#__PURE__*/function (_React__default$defau) {
  _inherits(PublicUrlProvider, _React__default$defau);

  var _super = _createSuper(PublicUrlProvider);

  function PublicUrlProvider() {
    _classCallCheck(this, PublicUrlProvider);

    return _super.apply(this, arguments);
  }

  _createClass(PublicUrlProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          children = _this$props.children;
      return /*#__PURE__*/React__default["default"].createElement(Provider, {
        value: url
      }, children);
    }
  }]);

  return PublicUrlProvider;
}(React__default["default"].PureComponent); // HOC wrapper


defineProperty._defineProperty(PublicUrlProvider, "propTypes", {
  url: index.PropTypes.string.isRequired,
  children: index.PropTypes.node
});

var hocWrap = function hocWrap(Component) {
  var HOC = function HOC(props) {
    return /*#__PURE__*/React__default["default"].createElement(Consumer, null, function (url) {
      return /*#__PURE__*/React__default["default"].createElement(Component, _extends._extends({}, props, {
        publicUrl: url
      }));
    });
  };

  HOC.displayName = "PublicUrlProvider(".concat(getDisplayName._default(Component), ")");
  return HOC;
}; // styled-components utility for URLs


var styledUrl = function styledUrl(url$1) {
  return function (_ref) {
    var publicUrl = _ref.publicUrl;
    return url.prefixUrl(url$1, publicUrl);
  };
};

var PublicUrl = function PublicUrl(props) {
  return /*#__PURE__*/React__default["default"].createElement(Consumer, props);
};

PublicUrl.Provider = PublicUrlProvider;
PublicUrl.hocWrap = hocWrap;
PublicUrl.styledUrl = styledUrl;

function usePublicUrl() {
  return React.useContext(PublicUrlContext);
}

exports.PublicUrl = PublicUrl;
exports.usePublicUrl = usePublicUrl;